export const getMmrImr = ({
  equity,
  im,
  mm,
}: {
  equity: number;
  im: number;
  mm: number;
}) => {
  const imr = equity !== 0 ? im / equity : 0;
  const mmr = equity !== 0 ? mm / equity : 0;

  return { imr, mmr };
};
